import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BasicDataTables, DataTables } from "../../../Constant";
import { ZeroConfigurationTable } from "./ZeroConfigurationTable";
import StateSaving from "./StateSaving";
import ScrollVerticalDynamicHeight from "./ScrollVerticalDynamicHeight";

const BasicDataTablesContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={BasicDataTables} parent={DataTables} title={BasicDataTables} />
      <Container fluid>
        <Row>
            <ZeroConfigurationTable/>
            <StateSaving/>
            <ScrollVerticalDynamicHeight/>
        </Row>
      </Container>
    </>
  );
};

export default BasicDataTablesContainer;
